<template>
    <div class="productoption">
        <div class="product-list__filter">
            <div class="row align-items-center">
                <div class="mt-4 pt-1 ml-2 ml-md-3">
                    <p class>
                        <span v-if="navOption.name != ''" class="ui text large-lg medium-md tiny-sm mini light color black fixfont mr-sm-3">{{navOption.name}}</span> 
                        <span class="ui text large-lg medium-md tiny-sm mini light color gray-7 d-inline-block ">
                            <span v-if="navOption.amount > 0" class="d-none d-sm-inline-block">{{$t('FindItem')}}</span>
                            {{(navOption.amount > 0)? '('+ navOption.amount +')' : ''}}
                        </span>
                    </p>
                </div>
                <div class="mt-4 ml-auto pr-2">
                    <span class="d-inline-block ui text large-lg medium-md tiny-sm mini light fixfont mr-lg-5"><span class="d-none d-sm-inline-block">{{$t('Price')}} :</span>
                        <div class="[ ui inline dropdown ] [ ml-1 ] dropdown-toggle color theme" id="optionPrice" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <input type="hidden" name="">
                            <div class="text" v-if="1 == navOption.optionPrice">{{$t('PriceLH')}}</div>
                            <div class="text" v-else>{{$t('PriceHL')}}</div>
                            <i class="dropdown icon"></i>
                            <div class="menu dropdown-menu" aria-labelledby="optionPrice">
                                <div v-on:click="optionPrice(1)" class="item" :class="{ 'active' : 1 == navOption.optionPrice}" data-value="1">{{$t('PriceLH')}}</div>
                                <div v-on:click="optionPrice(2)" class="item" :class="{ 'active' : 2 == navOption.optionPrice}" data-value="0">{{$t('PriceHL')}}</div>
                            </div>
                        </div>
                    </span>
                    <span class="d-inline-block mt-1 ui text large-lg medium-md tiny-sm mini fixfont light">
                        <span class="d-none d-sm-inline-block">{{$t('View')}} :</span> 
                        <a v-on:click="optionLayout(1)" class="filter__btn d-inline-block p-2 js-product-align-column "  :class="{ 'active' : 1 == navOption.optionLayout}">
                            <i class="fas fa-th-large"></i>
                        </a> 
                        <a v-on:click="optionLayout(2)" class="filter__btn d-inline-block p-2 js-product-align-horizontal" :class="{ 'active' : 2 == navOption.optionLayout}">
                            <i class="fas fa-align-justify"></i>
                        </a>
                    </span>
                </div>
            </div>
        </div>
    </div>  
</template>

<script>
export default {
    name: 'productoption',
    components: {},
    props: {
        navOption : {
            type: Object,
            default: {
                name: 'Unknown',
                amount: 0,
                optionLayout: 1,
                optionPrice: 1,
            }
        }
    },
    data () {
        return {
        }
    },
    computed: {
        
    },
    created () {
    },
    methods: {
        optionPrice : function(el){
            this.navOption.optionPrice = el
            this.saveOption()
        },
        optionLayout : function(el){
            this.navOption.optionLayout = el
            this.saveOption()
            if(el == 1){
                $('.js-product-align-horizontal').removeClass('active')
                $('.js-product-align-column').addClass('active')
                $('.type-f').addClass('align-column')
            }else{
                $('.js-product-align-column').removeClass('active')
                $('.js-product-align-horizontal').addClass('active')
                $('.type-f').removeClass('align-column')
            }
        },
        saveOption() {
            const optionPrice = this.navOption.optionPrice
            localStorage.setItem('optionPrice', optionPrice)
            const optionLayout = this.navOption.optionLayout
            localStorage.setItem('optionLayout', optionLayout)
        }
    }
}
</script>

<style lang="scss">
@media (min-width: 1100px){
    .ui.text.large-lg.fixfont{
        font-size: 1.275rem !important;
    }
}
</style>